import React, { ChangeEvent, useState } from "react";
import { UserData } from "../app/services/auth";
import LoginForm from "../components/Forms/LoginForm";

function LoginPage() {
    return (
        <>
            <LoginForm></LoginForm>
        </>
    );
}

export default LoginPage;
